// "Product & Blog Tags" アプリのタグ一覧 <nav> 内へ
// チェックボックス + ラベルを移動して、CSSで開閉できる状態にする。
// defer 読み込み前提（DOM パース後に実行されるので DOMContentLoaded 不要）。

(() => {
  const input = document.getElementById('blog-tag-toggle');
  const label = document.querySelector('.blog-tag-toggle__label');
  if (!input || !label) {
    console.warn('[blog-tag-toggle] input/label が見つかりません。Custom Liquid ブロックが配置されているか確認してください。');
    return;
  }

  // .ruffruff-tags 直下の <nav> を探す
  const container = document.querySelector('.ruffruff-tags');
  const nav = container?.querySelector('nav');
  if (!nav) {
    console.warn('[blog-tag-toggle] .ruffruff-tags 内の <nav> が見つかりませんでした。');
    return;
  }

  nav.appendChild(input);
  nav.appendChild(label);
})();
